import renderTitle from './renderTitle';
import { env } from '@zopauk/nextjs-env';
import { Heading, Text } from '@zopauk/react-components';
import type { PropsWithChildren, ReactNode } from 'react';
import { PreReleaseDisclaimer } from './components/PreReleaseDisclaimer/PreReleaseDisclaimer';
import { Heading as StyledHeading, BodyWrapper, Container, Subtitle, Page } from './index.styles';

export interface FullPageLayoutProps {
  mainCobrandedLegalCopy?: ReactNode;
  subtitle?: ReactNode | string;
  isCobranded?: boolean;
  title?: LayoutTitle;
  maxWidth?: number;
}
export type LayoutTitle =
  | {
      noHeaderTitle?: boolean;
      text: string;
    }
  | string;

export const FullPageLayout = (props: PropsWithChildren<FullPageLayoutProps>) => {
  const { maxWidth = 768, children, subtitle, title } = props;

  const { titleText } = renderTitle(title, subtitle);

  return (
    <>
      <PreReleaseDisclaimer enabled={env('APP_ENV') === 'uat'} />
      <Page>
        <Container maxWidth={maxWidth} fullHeight={true}>
          {title ? (
            <StyledHeading>
              <Heading as="h1">{titleText}</Heading>
              {subtitle ? (
                <Subtitle>
                  <Text size="lead" as="p">
                    {subtitle}
                  </Text>
                </Subtitle>
              ) : null}
            </StyledHeading>
          ) : null}
          <BodyWrapper>{children}</BodyWrapper>
        </Container>
      </Page>
    </>
  );
};
